import { render, staticRenderFns } from "./CoUserBioEdit.vue?vue&type=template&id=928d559c&"
import script from "./CoUserBioEdit.vue?vue&type=script&lang=js&"
export * from "./CoUserBioEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports